import React from 'react';
import { useAvatarNav } from './AvatarNavContext';
const USER_AVATAR_URL = 'https://cdn.magicpatterns.com/uploads/9KSQW1TfFTA7NGLfA1xyeD/Screenshot_2026-04-22_alle_14.07.40.png';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  trailing?: ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  trailing
}: PageHeaderProps) {
  const {
    openProfile
  } = useAvatarNav();
  return <header className="px-5 pt-6 pb-4 flex items-center justify-between gap-3 shrink-0 border-b border-[#2A2A2A]/50" data-id="element-157">
      <div className="min-w-0 flex-1" data-id="element-158">
        <h1 className="page-title text-[20px] font-[500]" data-id="element-159">{title}</h1>
        {subtitle && <p className="text-[14px] text-[#A0A0A0] mt-1 leading-relaxed" data-id="element-160">
            {subtitle}
          </p>}
      </div>
      <div className="flex items-center gap-3 shrink-0" data-id="element-161">
        {trailing && <div data-id="element-162">{trailing}</div>}
        <button onClick={openProfile} className="focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C5D82D] rounded-full" data-id="element-163">
          <img src={USER_AVATAR_URL} alt="Profile" className="w-12 h-12 rounded-full object-cover border border-[#2A2A2A]" data-id="element-164" />
        </button>
      </div>
    </header>;
}